import * as yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(yup);

export const changeProfilePasswordSchema = yup.object().shape({
  password: yup
    .string()
    .min(8, 'auth.passMinLength8')
    .minLowercase(1, 'auth.passNeedLowercase')
    .minUppercase(1, 'auth.passNeedUppercase')
    .minSymbols(1, 'auth.passNeedSymbol')
    .required('auth.passwordRequired'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'auth.passDiffErr')
});
